<div class="container-tabs">
  <div class="select-tab">
    <button type="submit" (click)="changeTab(1)">Categorias</button>
    <button type="submit" (click)="changeTab(2)">KPIs</button>
  </div>
  <div class="tab-1" *ngIf="tab">
    <div class="categories-container">
      <table mat-table [dataSource]="params" aria-label="Tabla de categorías">
        <ng-container matColumnDef="CategoryCode">
          <th mat-header-cell *matHeaderCellDef>
            Código categorías
          </th>
          <td mat-cell *matCellDef="let element"> {{element.CategoryCode}} </td>
        </ng-container>
        <ng-container matColumnDef="Description">
          <th mat-header-cell *matHeaderCellDef> Descripción </th>
          <td mat-cell *matCellDef="let element">
            <input [(ngModel)]="element.Description" type="text">
          </td>
        </ng-container>

        <ng-container matColumnDef="Clout">
          <th mat-header-cell *matHeaderCellDef> Influencia </th>
          <td mat-cell *matCellDef="let element">
            <input [(ngModel)]="element.Clout" type="text">
          </td>
        </ng-container>

        <ng-container matColumnDef="button">
          <th mat-header-cell *matHeaderCellDef> Actualizar</th>
          <td mat-cell *matCellDef="let element">
            <button type="submit" (click)="updateRowCategorie(element)">Actualizar párametro</button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
  <div class="tab-2" *ngIf="!tab">
    <div class="kpis-container">
      <div class="search">
        <form [formGroup]="search">
          <select style="margin: 0 10px 50px 0; width: 120px;" formControlName="select">
            <option *ngFor="let i of displayedColumnsKpis" [value]="i">{{i}}</option>
          </select>
          <input style="width: 300px" type="text" formControlName="result"
            placeholder="{{(placeHolder) ? 'Escribe para buscar por '+ placeHolder: 'Seleccione para poder buscar'}}"
            id="searcher">
        </form>
      </div>
      <table mat-table [dataSource]="paramsKpis" aria-label="Tabla de KPIs">
        <ng-container matColumnDef="IdCategory">
          <th mat-header-cell *matHeaderCellDef matTooltip="IdCategory" [matTooltipPosition]="'above'">Id</th>
          <td mat-cell *matCellDef="let e">{{e.IdCategory}}</td>
        </ng-container>
        <ng-container matColumnDef="Name">
          <th mat-header-cell *matHeaderCellDef matTooltip="Name" [matTooltipPosition]="'above'"> Nombre </th>
          <td mat-cell *matCellDef="let e"> {{e.Name}}</td>
        </ng-container>
        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef matTooltip="Status" [matTooltipPosition]="'above'"> Estado </th>
          <td mat-cell *matCellDef="let e">
            <input [(ngModel)]="e.Status" type="text">
          </td>
        </ng-container>
        <ng-container matColumnDef="Clout">
          <th mat-header-cell *matHeaderCellDef matTooltip="Clout" [matTooltipPosition]="'above'">Influencia </th>
          <td mat-cell *matCellDef="let e">
            <input [(ngModel)]="e.Clout" type="text">
          </td>
        </ng-container>
        <ng-container matColumnDef="Heart_lower">
          <th mat-header-cell *matHeaderCellDef matTooltip="Heart_lower" [matTooltipPosition]="'above'">Corazon Low
          </th>
          <td mat-cell *matCellDef="let e">
            <input [(ngModel)]="e.Heart_lower" type="text">
          </td>
        </ng-container>
        <ng-container matColumnDef="Heart_top">
          <th mat-header-cell *matHeaderCellDef matTooltip="Heart_top" [matTooltipPosition]="'above'">
            Corazon top
          </th>
          <td mat-cell *matCellDef="let e">
            <input [(ngModel)]="e.Heart_top" type="text">
          </td>
        </ng-container>
        <ng-container matColumnDef="Max_Medium_Score">
          <th mat-header-cell *matHeaderCellDef matTooltip="Max_Medium_Score" [matTooltipPosition]="'above'">
            Max/medio
          </th>
          <td mat-cell *matCellDef="let e">
            <input [(ngModel)]="e.Max_Medium_Score" type="text">
          </td>
        </ng-container>
        <ng-container matColumnDef="Max_Score">
          <th mat-header-cell *matHeaderCellDef matTooltip="Max_Score" [matTooltipPosition]="'above'">
            Max.
          </th>
          <td mat-cell *matCellDef="let e">
            <input [(ngModel)]="e.Max_Score" type="text">
          </td>
        </ng-container>
        <ng-container matColumnDef="Medium_Score">
          <th mat-header-cell *matHeaderCellDef matTooltip="Medium_Score" [matTooltipPosition]="'above'">
            Media
          </th>
          <td mat-cell *matCellDef="let e">
            <input [(ngModel)]="e.Medium_Score" type="text">
          </td>
        </ng-container>
        <ng-container matColumnDef="Min_Medium_Score">
          <th mat-header-cell *matHeaderCellDef matTooltip="Min_Medium_Score" [matTooltipPosition]="'above'">
            Min/Media
          </th>
          <td mat-cell *matCellDef="let e">
            <input [(ngModel)]="e.Min_Medium_Score" type="text">
          </td>
        </ng-container>
        <ng-container matColumnDef="Min_Score">
          <th mat-header-cell *matHeaderCellDef matTooltip="Min_Score" [matTooltipPosition]="'above'">
            Min.
          </th>
          <td mat-cell *matCellDef="let e">
            <input [(ngModel)]="e.Min_Score" type="text">
          </td>
        </ng-container>
        <ng-container matColumnDef="Value_Lower">
          <th mat-header-cell *matHeaderCellDef matTooltip="Value_Lower" [matTooltipPosition]="'above'">
            Menor valor
          </th>
          <td mat-cell *matCellDef="let e">
            <input [(ngModel)]="e.Value_Lower" type="text">
          </td>
        </ng-container>
        <ng-container matColumnDef="Value_Medium">
          <th mat-header-cell *matHeaderCellDef matTooltip="Value_Medium" [matTooltipPosition]="'above'">
            valor medio
          </th>
          <td mat-cell *matCellDef="let e">
            <input [(ngModel)]="e.Value_Medium" type="text">
          </td>
        </ng-container>
        <ng-container matColumnDef="Value_Medium_Max">
          <th mat-header-cell *matHeaderCellDef matTooltip="Value_Medium_Max" [matTooltipPosition]="'above'">
            Valor medio máximo
          </th>
          <td mat-cell *matCellDef="let e">
            <input [(ngModel)]="e.Value_Medium_Max" type="text">
          </td>
        </ng-container>
        <ng-container matColumnDef="Value_Medium_Min">
          <th mat-header-cell *matHeaderCellDef matTooltip="Value_Medium_Min" [matTooltipPosition]="'above'">
            valor medio minimo
          </th>
          <td mat-cell *matCellDef="let e">
            <input [(ngModel)]="e.Value_Medium_Min" type="text">
          </td>
        </ng-container>
        <ng-container matColumnDef="Value_Top">
          <th mat-header-cell *matHeaderCellDef matTooltip="Value_Top" [matTooltipPosition]="'above'">
            Mayor valor
          </th>
          <td mat-cell *matCellDef="let e">
            <input [(ngModel)]="e.Value_Top" type="text">
          </td>
        </ng-container>

        <ng-container matColumnDef="button">
          <th mat-header-cell *matHeaderCellDef>Actualizar</th>
          <td mat-cell *matCellDef="let e">
            <button type="submit" (click)="updateRowKPIs(e)">Actualizar</button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsKpis"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsKpis;"></tr>
      </table>
    </div>
  </div>
</div>
